import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { SharedModule } from '../shared/shared.module'
import { FundLiteratureComponent } from './fund-literature.component'

@NgModule({
  declarations: [FundLiteratureComponent],
  imports: [CommonModule, FormsModule, SharedModule],
  exports: [FundLiteratureComponent],
  providers: [],
})
export class FundLiteratureModule {}
